import { render, staticRenderFns } from "./PcComponent.vue?vue&type=template&id=1942c731&scoped=true&"
import script from "./PcComponent.vue?vue&type=script&lang=js&"
export * from "./PcComponent.vue?vue&type=script&lang=js&"
import style0 from "./PcComponent.vue?vue&type=style&index=0&id=1942c731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942c731",
  null
  
)

export default component.exports